/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ProjectSettingsServiceDeskExternalLinksType from '@jira/spa-apps__project-settings-service-desk-external-links/src/ExportedDefault.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type { usePathParam } from '@atlassian/react-resource-router';

export const LazyProjectSettingsServiceDeskExternalLinks: LazyComponent<
	React.FunctionComponent<
		Omit<
			Omit<
				{
					usePathParam: typeof usePathParam;
				},
				never
			> &
				Partial<unknown>,
			'usePathParam'
		>
	>
	// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
> = lazyForPaint<typeof ProjectSettingsServiceDeskExternalLinksType>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-project-settings-service-desk-external-links", jiraSpaEntry: "async-project-settings-service-desk-external-links" */ '@jira/spa-apps__project-settings-service-desk-external-links/src/ExportedDefault.tsx'
			),
		),
	{ ssr: false },
);

const AsyncProjectSettingsServiceDeskExternalLinks = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProjectSettingsServiceDeskExternalLinks}
		pageId="project-settings-external-links"
		shouldShowSpinner
	/>
);

export default AsyncProjectSettingsServiceDeskExternalLinks;
